import { useContactsStore } from '@/stores/contacts-store';
import { useMapStore } from '@/stores/map-store';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Users } from 'lucide-react';

/** Contacts list panel — click to fly to contact on map */
export function ContactsPanel(): React.JSX.Element {
  const contacts = useContactsStore((s) => s.contacts);
  const setFlyTo = useMapStore((s) => s.setFlyTo);

  return (
    <div className="flex flex-1 flex-col gap-2 overflow-hidden p-4">
      <div className="flex items-center gap-1.5 border-b border-echo-border pb-2">
        <Users className="h-3.5 w-3.5 text-muted-foreground" />
        <span className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
          {contacts.length} contact{contacts.length !== 1 ? 's' : ''}
        </span>
      </div>
      <ScrollArea className="flex-1">
        <ul className="flex flex-col gap-1">
          {contacts.map((contact) => (
            <li
              key={contact.uid}
              className="cursor-pointer rounded-md bg-white/[0.04] px-3 py-2 text-sm transition-colors hover:bg-white/[0.08]"
              onClick={() => {
                if (contact.lat !== undefined && contact.lon !== undefined) {
                  setFlyTo({ lng: contact.lon, lat: contact.lat, zoom: 14 });
                }
              }}
            >
              <div className="flex items-center gap-2">
                <span className="h-2 w-2 shrink-0 rounded-full bg-echo-yellow" />
                <span className="font-semibold text-foreground">
                  {contact.callsign ?? contact.uid ?? 'Unknown'}
                </span>
              </div>
              <span className="mt-0.5 block pl-4 text-[11px] text-muted-foreground">
                {contact.uid}
              </span>
            </li>
          ))}
        </ul>
      </ScrollArea>
    </div>
  );
}
